import dayjs from 'dayjs'
import S3 from 'aws-s3'
import { VERSION_APP } from 'consts'

export function formatCash(str) {
  if (str)
    return str
      .toString()
      .split('')
      .reverse()
      .reduce((prev, next, index) => {
        return (index % 3 ? next : next + ',') + prev
      })
  else return 0
}

export const decodeJWT = (_token) => {
  if (typeof _token !== 'string') {
    return false
  }
  const _splitToken = _token.split('.')
  if (_splitToken.length !== 3) {
    return false
  }
  try {
    const payload = JSON.parse(atob(_splitToken[1]))
    // if (payload.role === 'client') {
    //   if (!payload.permissions) {
    //     payload.permissions = []
    //   }
    //   payload.permissions = [
    //     ...payload.permissions,
    //   ]
    // }
    return payload
  } catch (error) {
    return null
  }
}

export const uploadFiles = async (files) => {
  try {
    /* config s3 */
    const _d = dayjs(new Date()).format('YYYY/MM/DD')
    const config = {
      bucketName: process.env.REACT_APP_BUCKET_NAME,
      region: process.env.REACT_APP_REGION,
      accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    }
    /* config s3 */

    const listPromise = files.map(async (file) => {
      const ReactS3Client = new S3(config)
      let fileName = file.name.split('.')

      //check type file và thay đổi type file
      //check đuôi file là gì thì set type trong object file giá trị đó
      Object.defineProperty(file, 'type', {
        value: `application/${fileName[fileName.length - 1]}`,
        writable: true,
      })

      fileName.splice(fileName.length - 1, 1)

      const res = await ReactS3Client.uploadFile(
        file,
        _d + '/' + fileName.toString().replaceAll(',', '.')
      )
      if (res && res.status === 204) return res.location
    })

    const results = Promise.all(listPromise)
    return results || []
  } catch (error) {
    console.log(error)
  }
}

export const uploadFile = async (file) => {
  try {
    /* config s3 */
    const _d = dayjs(new Date()).format('YYYY/MM/DD')
    const config = {
      bucketName: process.env.REACT_APP_BUCKET_NAME,
      region: process.env.REACT_APP_REGION,
      accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    }
    /* config s3 */

    const ReactS3Client = new S3(config)
    let fileName = file.name.split('.')

    //check type file và thay đổi type file
    //check đuôi file là gì thì set type trong object file giá trị đó
    Object.defineProperty(file, 'type', {
      value: `application/${fileName[fileName.length - 1]}`,
      writable: true,
    })

    fileName.splice(fileName.length - 1, 1)

    const res = await ReactS3Client.uploadFile(
      file,
      _d + '/' + fileName.toString().replaceAll(',', '.')
    )
    if (res && res.status === 204) return res.location
    return ''
  } catch (error) {
    console.log(error)
  }
}

export const getTimeRange = (value) => {
  switch (value) {
    case 'to_day':
      return {
        from_date: dayjs().format('YYYY-MM-DD'),
        to_date: dayjs().format('YYYY-MM-DD'),
      }
    case 'yesterday':
      return {
        from_date: dayjs().subtract(1, 'days').format('YYYY-MM-DD'),
        to_date: dayjs().subtract(1, 'days').format('YYYY-MM-DD'),
      }
    case 'this_week':
      return {
        from_date: dayjs().startOf('week').format('YYYY-MM-DD'),
        to_date: dayjs().endOf('week').format('YYYY-MM-DD'),
      }
    case 'last_week':
      return {
        from_date: dayjs()
          .subtract(1, 'weeks')
          .startOf('week')
          .format('YYYY-MM-DD'),
        to_date: dayjs()
          .subtract(1, 'weeks')
          .endOf('week')
          .format('YYYY-MM-DD'),
      }
    case 'this_month':
      return {
        from_date: dayjs().startOf('month').format('YYYY-MM-DD'),
        to_date: dayjs().format('YYYY-MM-DD'),
      }
    case 'last_month':
      return {
        from_date: dayjs()
          .subtract(1, 'month')
          .startOf('month')
          .format('YYYY-MM-DD'),
        to_date: dayjs()
          .subtract(1, 'month')
          .endOf('month')
          .format('YYYY-MM-DD'),
      }
    case 'this_year':
      return {
        from_date: dayjs().startOf('years').format('YYYY-MM-DD'),
        to_date: dayjs().endOf('years').format('YYYY-MM-DD'),
      }
    case 'last_year':
      return {
        from_date: dayjs()
          .subtract(1, 'year')
          .startOf('year')
          .format('YYYY-MM-DD'),
        to_date: dayjs()
          .subtract(1, 'year')
          .endOf('year')
          .format('YYYY-MM-DD'),
      }
    default:
      return {
        from_date: '',
        to_date: '',
      }
  }
}

/**
 * Dọn cache trình duyệt khi phát hiện bản mới.
 *
 * TRƯỚC ĐÂY hàm này gọi localStorage.clear() + reload cứng. Khi VERSION_APP còn hardcode thì hiếm
 * khi chạy nên không ai để ý. Từ khi version tự tăng mỗi lần deploy (scripts/bump-version.js),
 * cách cũ sẽ xoá luôn accessToken/refreshToken => ĐĂNG XUẤT TOÀN BỘ USER sau mỗi lần deploy.
 *
 * Nay chỉ xoá Cache Storage (không đụng localStorage) và không tự reload —
 * việc nạp lại đúng thời điểm do src/hooks/use-auto-update.js đảm nhiệm.
 */
export const clearBrowserCache = () => {
  const version = localStorage.getItem('version_app')
  if (version === VERSION_APP) return

  if ('caches' in window) {
    caches
      .keys()
      .then((names) => names.forEach((name) => caches.delete(name)))
      .catch(() => {})
  }

  localStorage.setItem('version_app', VERSION_APP)
}
